import React, { useEffect, useState, createElement } from 'react';
import { SocialProofBanner } from '../components/SocialProofBanner';
import { HeroSection } from '../components/HeroSection';
import { TestimonialStrip } from '../components/TestimonialStrip';
import { EmpathySection } from '../components/EmpathySection';
import { AspirationalSection } from '../components/AspirationalSection';
import { ValueStack } from '../components/ValueStack';
import { SecondProofStrip } from '../components/SecondProofStrip';
import { OrderBump } from '../components/OrderBump';
import { CheckoutSection } from '../components/CheckoutSection';
import { StickyCTA } from '../components/StickyCTA';
import { TrustSection } from '../components/TrustSection';
import { Footer } from '../components/Footer';
export function LandingPage() {
  const [isBumpSelected, setIsBumpSelected] = useState(false);
  const basePrice = 9.95;
  const bumpPrice = 4.9;
  const totalPrice = isBumpSelected ? basePrice + bumpPrice : basePrice;
  useEffect(() => {
    // Initialize Meta Pixel and fire PageView
    if (typeof window !== 'undefined' && !(window as any).fbq) {
      // Initialize fbq function
      ;
      (window as any).fbq = function () {
        ;
        (window as any).fbq.callMethod ? (window as any).fbq.callMethod.apply((window as any).fbq, arguments) : (window as any).fbq.queue.push(arguments);
      };
      (window as any).fbq.push = (window as any).fbq;
      (window as any).fbq.loaded = true;
      (window as any).fbq.version = '2.0';
      (window as any).fbq.queue = [];
      // Load Meta Pixel script
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      script.onload = () => {
        ;
        (window as any).fbq('init', '741445578526747');
        (window as any).fbq('track', 'PageView');
      };
      document.head.appendChild(script);
    } else if (typeof window !== 'undefined' && (window as any).fbq) {
      // If fbq already exists, just track PageView
      ;
      (window as any).fbq('track', 'PageView');
    }
  }, []);
  return <div className="min-h-screen bg-white relative" data-id="element-195">
      <SocialProofBanner data-id="element-196" />

      <main data-id="element-197">
        <HeroSection data-id="element-198" />
        <TestimonialStrip data-id="element-199" />
        <EmpathySection data-id="element-200" />
        <AspirationalSection data-id="element-201" />
        <ValueStack data-id="element-202" />
        <SecondProofStrip data-id="element-203" />

        <div className="bg-gray-50 pt-8 px-4" data-id="element-204">
          <OrderBump isBumpSelected={isBumpSelected} setIsBumpSelected={setIsBumpSelected} data-id="element-205" />
        </div>

        <CheckoutSection totalPrice={totalPrice} isBumpSelected={isBumpSelected} data-id="element-206" />

        <TrustSection data-id="element-207" />
      </main>

      <Footer data-id="element-208" />
      <StickyCTA data-id="element-209" />

      {/* Meta Pixel noscript fallback */}
      <noscript data-id="element-210">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=741445578526747&ev=PageView&noscript=1" alt="" data-id="element-211" />
      </noscript>
    </div>;
}